import CONFIG from '../../config';

const actions = {
  applicationMarketplace(context) {
    context.commit('ADD_LOG', { request: 'applicationMarketplace' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationMarketplace'), {
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationMarketplace' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationMarketplace' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationFile(context, params) {
    context.commit('ADD_LOG', { request: 'applicationFile' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationFile', params.fileId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          responseType: 'blob',
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationFile' });
          resolve(response.data);
        })
        .catch(async (err) => {
          const errBlob = JSON.parse(await err.response.data.text());
          context.commit('REMOVE_LOG', { request: 'applicationFile' });
          context.dispatch('resolveError', { errBlob })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationMarketplaceMemberships(context, id) {
    context.commit('ADD_LOG', { request: 'applicationMarketplaceMemberships' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationMarketplaceMemberships', id), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationMarketplaceMemberships' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationMarketplaceMemberships' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationStores(context, params) {
    context.commit('ADD_LOG', { request: 'applicationStores' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationStores'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationStores' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationStores' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  getPincode(context, pincode) {
    context.commit('ADD_LOG', { request: 'applicationCityAndState' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationCityAndState', pincode), {
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationCityAndState' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationCityAndState' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationBankDetails(context, ifscCode) {
    context.commit('ADD_LOG', { request: 'applicationBankDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationBankDetails', ifscCode), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationBankDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationBankDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationIsGstVerified(context, params) {
    context.commit('ADD_LOG', { request: 'applicationIsGstVerified' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationIsGstVerified', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationIsGstVerified' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationIsGstVerified' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationApprovals(context, params) {
    context.commit('ADD_LOG', { request: 'applicationApprovals' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationApprovals', params.applicationId), {
          params: params.urlParams,
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationApprovals' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationApprovals' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationPostApprovalSubmission(context, params) {
    context.commit('ADD_LOG', { request: 'applicationPostApprovalSubmission' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationPostApprovalSubmission', params.applicationId), params.patchParams, {
          params: params.urlParams,
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationPostApprovalSubmission' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationPostApprovalSubmission' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  creditLoanPostApprovalSubmission(context, params) {
    context.commit('ADD_LOG', { request: 'creditLoanPostApprovalSubmission' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('creditLoanPostApprovalSubmission', params.creditLoan), params.patchParams, {
          params: params.urlParams,
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'creditLoanPostApprovalSubmission' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'creditLoanPostApprovalSubmission' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationSummary(context, params) {
    context.commit('ADD_LOG', { request: 'applicationSummary' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationSummary', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationSummary' });
          context.commit('SAVE_APPLICATION_SUMMARY', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationSummary' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationBusinessOwnershipInfo(context, params) {
    context.commit('ADD_LOG', { request: 'applicationBusinessOwnershipInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationBusinessOwnershipInfo', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationBusinessOwnershipInfo' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationBusinessOwnershipInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationSubmit(context, params) {
    context.commit('ADD_LOG', { request: 'applicationSubmit' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationSubmit', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationSubmit' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationSubmit' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v2ApplicationSubmit(context, params) {
    context.commit('ADD_LOG', { request: 'v2ApplicationSubmit' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('v2ApplicationSubmit', params.applicationId), params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v2ApplicationSubmit' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v2ApplicationSubmit' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationMarketplaceAccountLinkingComplete(context, params) {
    context.commit('ADD_LOG', { request: 'applicationMarketplaceAccountLinkingComplete' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationMarketplaceAccountLinkingComplete', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationMarketplaceAccountLinkingComplete' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationMarketplaceAccountLinkingComplete' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationAddressProof(context, params) {
    context.commit('ADD_LOG', { request: 'applicationAddressProof' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationAddressProof', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationAddressProof' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationAddressProof' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v3ApplicationAddressProof(context, params) {
    context.commit('ADD_LOG', { request: 'v3ApplicationAddressProof' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('v3ApplicationAddressProof', params.applicationId), params.formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: localStorage.getItem('token')
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v3ApplicationAddressProof' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v3ApplicationAddressProof' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationAddressProof1(context, params) {
    context.commit('ADD_LOG', { request: 'applicationAddressProof1' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationAddressProof1', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationAddressProof1' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationAddressProof1' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationBusinessRegistrationProof(context, params) {
    context.commit('ADD_LOG', { request: 'applicationBusinessRegistrationProof' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationBusinessRegistrationProof', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationBusinessRegistrationProof' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationBusinessRegistrationProof' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationSecurityCheque(context, params) {
    context.commit('ADD_LOG', { request: 'applicationSecurityCheque' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationSecurityCheque', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationSecurityCheque' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationSecurityCheque' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationPropertyOwnershipProof(context, params) {
    context.commit('ADD_LOG', { request: 'applicationPropertyOwnershipProof' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationPropertyOwnershipProof', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationPropertyOwnershipProof' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationPropertyOwnershipProof' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationShopPhotoInside(context, params) {
    context.commit('ADD_LOG', { request: 'applicationShopPhotoInside' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationShopPhotoInside', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationShopPhotoInside' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationShopPhotoInside' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationShopPhotoFront(context, params) {
    context.commit('ADD_LOG', { request: 'applicationShopPhotoFront' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationShopPhotoFront', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationShopPhotoFront' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationShopPhotoFront' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationApplicantPhoto(context, params) {
    context.commit('ADD_LOG', { request: 'applicationApplicantPhoto' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationApplicantPhoto', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationApplicantPhoto' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationApplicantPhoto' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationIdProof(context, params) {
    context.commit('ADD_LOG', { request: 'applicationIdProof' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationIdProof', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationIdProof' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationIdProof' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationCancelledCheque(context, params) {
    context.commit('ADD_LOG', { request: 'applicationCancelledCheque' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationCancelledCheque', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationCancelledCheque' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationCancelledCheque' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationBankStatement(context, params) {
    context.commit('ADD_LOG', { request: 'applicationBankStatement' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationBankStatement', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationBankStatement' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationBankStatement' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationApplicationDocument(context, params) {
    context.commit('ADD_LOG', { request: 'applicationApplicationDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationApplicationDocument', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationApplicationDocument' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationApplicationDocument' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationMarketplaceDocument(context, params) {
    context.commit('ADD_LOG', { request: 'applicationMarketplaceDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationMarketplaceDocument', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationMarketplaceDocument' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationMarketplaceDocument' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationFos(context, params) {
    context.commit('ADD_LOG', { request: 'applicationFos' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationFos', params.applicationId), {
          ...params.patchParams
        }, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationFos' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationFos' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationPersonalId(context, params) {
    context.commit('ADD_LOG', { request: 'applicationPersonalId' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('v2ApplicationPersonalId', params.applicationId),
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationPersonalId' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationPersonalId' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationPersonalInfo(context, params) {
    context.commit('ADD_LOG', { request: 'applicationPersonalInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('v2ApplicationPersonalInfo', params.applicationId),
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationPersonalInfo' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationPersonalInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v3ApplicationPersonalInfo(context, params) {
    context.commit('ADD_LOG', { request: 'v3ApplicationPersonalInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('v3ApplicationPersonalInfo', params.applicationId),
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v3ApplicationPersonalInfo' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v3ApplicationPersonalInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v4ApplicationPersonalInfo(context, params) {
    context.commit('ADD_LOG', { request: 'v4ApplicationPersonalInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('v4ApplicationPersonalInfo', params.applicationId),
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v4ApplicationPersonalInfo' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v4ApplicationPersonalInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  getApplicationPersonalInfo(context, params) {
    context.commit('ADD_LOG', { request: 'getApplicationPersonalInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationPersonalInfo', params.applicationId),
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'getApplicationPersonalInfo' });
          context.commit('SET_WELCOME_REWARDS_DATA', response.data.welcomeReward);
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'getApplicationPersonalInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  getApplicationPersonalKyc(context, params) {
    context.commit('ADD_LOG', { request: 'getApplicationPersonalKyc' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationPersonalKyc', params.applicationId),
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'getApplicationPersonalKyc' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'getApplicationPersonalKyc' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  getApplicationBusinessInfo(context, params) {
    context.commit('ADD_LOG', { request: 'getApplicationBusinessInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationBusinessInfo', params.applicationId),
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'getApplicationBusinessInfo' });
          context.commit('SET_WELCOME_REWARDS_DATA', response.data.welcomeReward);
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'getApplicationBusinessInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationPersonalKyc(context, params) {
    context.commit('ADD_LOG', { request: 'applicationPersonalKyc' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationPersonalKyc', params.applicationId),
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            }
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationPersonalKyc' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationPersonalKyc' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationBusinessInfo(context, params) {
    context.commit('ADD_LOG', { request: 'applicationBusinessInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationBusinessInfoV2', params.applicationId),
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token'),
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationBusinessInfo' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationBusinessInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v3ApplicationBusinessInfo(context, params) {
    context.commit('ADD_LOG', { request: 'v3ApplicationBusinessInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('v3ApplicationBusinessInfo', params.applicationId),
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token'),
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v3ApplicationBusinessInfo' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v3ApplicationBusinessInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationSkipBusinessRegistrationInfo(context, params) {
    context.commit('ADD_LOG', { request: 'applicationSkipBusinessRegistrationInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationSkipBusinessRegistrationInfo', params.applicationId),
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token'),
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationSkipBusinessRegistrationInfo' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationSkipBusinessRegistrationInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationQuestionnaire(context, params) {
    context.commit('ADD_LOG', { request: 'applicationQuestionnaire' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationQuestionnaire', params.applicationId),
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            }
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationQuestionnaire' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationQuestionnaire' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationPan(context, params) {
    context.commit('ADD_LOG', { request: 'applicationPan' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationPan', params.applicationId),
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationPan' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationPan' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationState(context) {
    context.commit('ADD_LOG', { request: 'applicationState' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationState'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationState' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationState' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationTnc(context, params) {
    context.commit('ADD_LOG', { request: 'applicationTnc' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(`${CONFIG.getEndpoint('applicationTnc', params.applicationId)}`,
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            }
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationTnc' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationTnc' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationRegistrationDetails(context, params) {
    context.commit('ADD_LOG', { request: 'applicationRegistrationDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(`${CONFIG.getEndpoint('applicationRegistrationDetails', params.applicationId)}`,
          params.patchParams,
          {
            headers:
            {
              Authorization: localStorage.getItem('token')
            },
            params: params.urlParams
          })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationRegistrationDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationRegistrationDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  application(context) {
    context.commit('ADD_LOG', { request: 'application' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(`${CONFIG.getEndpoint('application')}`, {}, {
          headers:
          {
            'x-phone-number': localStorage.getItem('phone'),
            Authorization: localStorage.getItem('token')
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'application' });
          context.commit('SAVE_APPLICATION_ID', response.data.id);
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'application' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationProfile(context, params) {
    context.commit('ADD_LOG', { request: 'applicationProfile' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('applicationProfile', params.applicationId)}`, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('APPLICATION_PROFILE_DATA', response.data);
          context.commit('REMOVE_LOG', { request: 'applicationProfile' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationProfile' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationTncDocument(context, params) {
    context.commit('ADD_LOG', { request: 'applicationTncDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(`${CONFIG.getEndpoint('applicationTncDocument', params.applicationId)}`, {}, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          responseType: 'blob'
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationTncDocument' });
          resolve(response.data);
        })
        .catch(async (err) => {
          const errBlob = JSON.parse(await err.response.data.text());
          context.commit('REMOVE_LOG', { request: 'applicationTncDocument' });
          context.dispatch('resolveError', { errBlob })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationNbfcSignedDocument(context,) {
    context.commit('ADD_LOG', { request: 'applicationNbfcSignedDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationNbfcSignedDocument'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationNbfcSignedDocument' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationNbfcSignedDocument' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationVaDetails(context) {
    context.commit('ADD_LOG', { request: 'applicationVaDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('applicationVaDetails')}`, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationVaDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationVaDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationSelectNbfc(context, params) {
    context.commit('ADD_LOG', { request: 'applicationSelectNbfc' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(`${CONFIG.getEndpoint('applicationSelectNbfc', params.applicationId)}`, params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationSelectNbfc' });
          context.commit('SET_LATEST_LOAN_ID', response.data.loanId);
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationSelectNbfc' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationBankInfo(context, params) {
    context.commit('ADD_LOG', { request: 'applicationBankInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(`${CONFIG.getEndpoint('applicationBankInfo', params.applicationId)}`, params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationBankInfo' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationBankInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v2ApplicationBankInfo(context, params) {
    context.commit('ADD_LOG', { request: 'v2ApplicationBankInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(`${CONFIG.getEndpoint('v2ApplicationBankInfo', params.applicationId)}`, params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.queryParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v2ApplicationBankInfo' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v2ApplicationBankInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  getApplicationBankInfo(context, params) {
    context.commit('ADD_LOG', { request: 'getApplicationBankInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('applicationBankInfo', params.applicationId)}`, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'getApplicationBankInfo' });
          resolve(response.data);
          context.commit('SET_WELCOME_REWARDS_DATA', response.data.welcomeReward);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'getApplicationBankInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  task(context, params) {
    context.commit('ADD_LOG', { request: 'task' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('task', params.taskId)}`, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'task' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'task' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationVernacularDeclaration(context) {
    context.commit('ADD_LOG', { request: 'applicationVernacularDeclaration' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('applicationVernacularDeclaration')}`, {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationVernacularDeclaration' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationVernacularDeclaration' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationVernacularDeclarationById(context, params) {
    context.commit('ADD_LOG', { request: 'applicationVernacularDeclarationById' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationVernacularDeclarationById', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationVernacularDeclarationById' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationVernacularDeclarationById' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationDualName(context, params) {
    context.commit('ADD_LOG', { request: 'applicationDualName' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationDualName', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationDualName' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationDualName' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationDualDob(context, params) {
    context.commit('ADD_LOG', { request: 'applicationDualDob' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationDualDob', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationDualDob' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationDualDob' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationDocumentUploadComplete(context, params) {
    context.commit('ADD_LOG', { request: 'applicationDocumentUploadComplete' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationDocumentUploadComplete', params.latestLoanId), {}, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationDocumentUploadComplete' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationDocumentUploadComplete' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationNachTemplate(context, params) {
    context.commit('ADD_LOG', { request: 'applicationNachTemplate' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(`${CONFIG.getEndpoint('applicationNachTemplate', params.applicationId)}${params.mandateUid}`, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationNachTemplate' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationNachTemplate' });
          context.dispatch('resolveErrorGatewayTimeOut', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationNachMandate(context, params) {
    context.commit('ADD_LOG', { request: 'applicationNachMandate' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(`${CONFIG.getEndpoint('applicationNachMandate', params.applicationId)}${params.loanId}`, params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationNachMandate' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationNachMandate' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationSkipMarketplaceDocument(context, params) {
    context.commit('ADD_LOG', { request: 'applicationSkipMarketplaceDocument' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationSkipMarketplaceDocument', params.applicationId), params.patchParams, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationSkipMarketplaceDocument' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationSkipMarketplaceDocument' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationOwnershipType(context) {
    context.commit('ADD_LOG', { request: 'applicationOwnershipType' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationOwnershipType'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationOwnershipType' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationOwnershipType' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationEducationQualifications(context) {
    context.commit('ADD_LOG', { request: 'applicationEducationQualifications' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationEducationQualifications'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationEducationQualifications' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationEducationQualifications' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationBusinessTypeAndCategory(context) {
    context.commit('ADD_LOG', { request: 'applicationBusinessTypeAndCategory' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationBusinessTypeAndCategory'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationBusinessTypeAndCategory' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationBusinessTypeAndCategory' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationAccountType(context) {
    context.commit('ADD_LOG', { request: 'applicationAccountType' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationAccountType'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationAccountType' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationAccountType' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationGst(context, params) {
    context.commit('ADD_LOG', { request: 'applicationGst' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationGst', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationGst' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationGst' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationContinueAnyway(context, params) {
    context.commit('ADD_LOG', { request: 'applicationContinueAnyway' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationContinueAnyway', params.applicationId), undefined, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.queryParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationContinueAnyway' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationContinueAnyway' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationComments(context, params) {
    context.commit('ADD_LOG', { request: 'applicationComments' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationComments', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationComments' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationComments' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  customerSupport(context, params) {
    context.commit('ADD_LOG', { request: 'customerSupport' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('customerSupport', params.supportId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'customerSupport' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'customerSupport' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationResolveComment(context, params) {
    context.commit('ADD_LOG', { request: 'applicationResolveComment' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(CONFIG.getEndpoint('applicationResolveComment', params.applicationId), params.formData, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationResolveComment' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationResolveComment' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationCreditScore(context, params) {
    context.commit('ADD_LOG', { request: 'applicationCreditScore' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationCreditScore', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationCreditScore' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationCreditScore' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  perfiosNetbanking(context, params) {
    context.commit('ADD_LOG', { request: 'perfiosNetbanking' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('perfiosNetbanking', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'perfiosNetbanking' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'perfiosNetbanking' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  creditloanApprovedAmountDetails(context, params) {
    context.commit('ADD_LOG', { request: 'creditloanApprovedAmountDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('creditloanApprovedAmountDetails', params.loanId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'creditloanApprovedAmountDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'creditloanApprovedAmountDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  signDesk(context) {
    context.commit('ADD_LOG', { request: 'signdesk' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('signdesk'), {
          headers: {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'signdesk' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'signdesk' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  paymentDetails(context, params) {
    context.commit('ADD_LOG', { request: 'paymentDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('paymentDetails', params.paymentDetailsId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'paymentDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'paymentDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  createConsentOneMoney(context) {
    context.commit('ADD_LOG', { request: 'createConsentOneMoney' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('createConsentOneMoney'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          }
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'createConsentOneMoney' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'createConsentOneMoney' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  applicationNachTemplateUrl(context, params) {
    context.commit('ADD_LOG', { request: 'applicationNachTemplateUrl' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('applicationNachTemplateUrl', params.applicationId), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
          params: params.urlParams
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'applicationNachTemplateUrl' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'applicationNachTemplateUrl' });
          context.dispatch('resolveErrorGatewayTimeOut', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  getLoanDocLanguageList(context) {
    context.commit('ADD_LOG', { request: 'getLoanDocLanguageList' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('getLoanDocLanguageList'), {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'getLoanDocLanguageList' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'getLoanDocLanguageList' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  loanDocLanguage(context) {
    context.commit('ADD_LOG', { request: 'loanDocLanguage' });
    return new Promise((resolve, reject) => {
      this.axios
        .get(CONFIG.getEndpoint('loanDocLanguage'), {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'loanDocLanguage' });
          context.commit('SAVE_LANGUAGE', response.data.languageList[0]?.languageType || 'english');
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'loanDocLanguage' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  updateLoanDocLanguage(context, params) {
    context.commit('ADD_LOG', { request: 'loanDocLanguage' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('loanDocLanguage'), { ...params }, {
          headers:
          {
            Authorization: localStorage.getItem('token')
          },
        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'loanDocLanguage' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'loanDocLanguage' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  v2CreditLoanBankInfo(context, params) {
    context.commit('ADD_LOG', { request: 'v2CreditLoanBankInfo' });
    return new Promise((resolve, reject) => {
      this.axios
        .patch(`${CONFIG.getEndpoint('v2CreditLoanBankInfo', params.loanId)}`, {
          ...params?.patchParams
        }, {
          headers:
          {
            Authorization: localStorage.getItem('token'),
          },

        })
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'v2CreditLoanBankInfo' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'v2CreditLoanBankInfo' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
};
export default actions;
